import { Link } from "react-router-dom";

const SERVICES = [
  { label: "Tree Removal", href: "/services/tree-removal" },
  { label: "Tree Trimming", href: "/services/tree-trimming" },
  { label: "Stump Grinding", href: "/services/stump-grinding" },
  { label: "All Services", href: "/services" },
];

const QUICK_LINKS = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Gallery", href: "/gallery" },
  { label: "Reviews", href: "/reviews" },
  { label: "Our Process", href: "/process" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" },
];

const SERVICE_AREAS = [
  "Fredericksburg, VA",
  "Stafford County, VA",
  "Spotsylvania, VA",
  "King George, VA",
  "Culpeper, VA",
  "Warrenton, VA",
  "Manassas, VA",
  "Woodbridge, VA",
];

export default function Footer() {
  return (
    <footer className="bg-[#1e1e1e] text-white">
      {/* CTA Strip */}
      <div className="bg-[#e8632a] py-6 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <p className="text-white font-black text-2xl">Ready to get started?</p>
            <p className="text-white/80 text-sm">Call us today for a free estimate — no obligation, no hassle.</p>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="tel:+15407764488"
              className="flex items-center gap-2 px-6 py-3 bg-white text-[#e8632a] font-bold rounded-lg uppercase tracking-wide hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              (540) 776-4488
            </a>
            <Link
              to="/contact"
              className="px-6 py-3 border-2 border-white text-white font-bold rounded-lg uppercase tracking-wide hover:bg-white hover:text-[#e8632a] transition-all cursor-pointer whitespace-nowrap"
            >
              Get Free Estimate
            </Link>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <div className="text-white font-black text-xl tracking-tight uppercase">Diversified</div>
              <div className="text-[#e8632a] font-black text-xl tracking-tight uppercase -mt-1">Tree Services</div>
              <div className="text-gray-400 font-semibold text-[10px] tracking-widest uppercase">LLC · Licensed & Insured</div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Northern Virginia's trusted tree removal, trimming, and stump grinding specialists. Serving homeowners with expert care since 2008.
            </p>
            <div className="flex items-center gap-3">
              {["ri-facebook-fill", "ri-instagram-line", "ri-google-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#e8632a] transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-2 border-b border-white/10">
              Our Services
            </h3>
            <ul className="space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.href}>
                  <Link
                    to={s.href}
                    className="text-gray-400 hover:text-[#e8632a] text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-[#e8632a]"></i>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h3 className="text-white font-bold text-sm uppercase tracking-widest mt-8 mb-5 pb-2 border-b border-white/10">
              Quick Links
            </h3>
            <ul className="space-y-2.5">
              {QUICK_LINKS.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-gray-400 hover:text-[#e8632a] text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-[#e8632a]"></i>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-2 border-b border-white/10">
              Service Areas
            </h3>
            <ul className="space-y-2.5">
              {SERVICE_AREAS.map((area) => (
                <li key={area}>
                  <Link
                    to="/service-areas"
                    className="text-gray-400 hover:text-[#e8632a] text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-map-pin-line text-[#e8632a]"></i>
                    {area}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-2 border-b border-white/10">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li>
                <a href="tel:+15407764488" className="flex items-start gap-3 group cursor-pointer">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#e8632a] rounded-lg flex-shrink-0 mt-0.5">
                    <i className="ri-phone-fill text-white text-sm"></i>
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs uppercase tracking-wide">Phone</p>
                    <p className="text-white font-semibold group-hover:text-[#e8632a] transition-colors">(540) 776-4488</p>
                  </div>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#e8632a] rounded-lg flex-shrink-0 mt-0.5">
                  <i className="ri-mail-fill text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-xs uppercase tracking-wide">Email</p>
                  <a href="mailto:info@diversifiedtreeservices.com" className="text-white font-semibold hover:text-[#e8632a] transition-colors text-sm">
                    info@diversifiedtreeservices.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#e8632a] rounded-lg flex-shrink-0 mt-0.5">
                  <i className="ri-time-fill text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-xs uppercase tracking-wide">Hours</p>
                  <p className="text-white font-semibold text-sm">Mon–Sat: 7am – 7pm</p>
                  <p className="text-gray-400 text-xs">Emergency service available 24/7</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#e8632a] rounded-lg flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-fill text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-xs uppercase tracking-wide">Service Area</p>
                  <p className="text-white font-semibold text-sm">Northern Virginia & Surrounding</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Diversified Tree Services LLC. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-fill text-[#e8632a]"></i>
              Licensed & Insured
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-star-fill text-[#e8632a]"></i>
              5-Star Rated
            </span>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
